import React from 'react';
import styled from 'styled-components';

const TabsContainer = styled.nav`
    width: 100%;
    font-family: inherit;
    font-size: ${props => props.fontSize ? props.fontSize : '16px'};
    height: ${props => props.height ? props.height : '35px'};
    display: grid;
    text-align: center;
    grid-template-columns: repeat(${props => props.children[0].length},minmax(${props => props.minWidth ? props.minWidth : 'max-content'},.2fr)) auto;
    grid-template-rows: 100%;

    & a {
        color: ${props => props.color ? props.color : '#000'};
        font-weight: 500;
        border-width: ${props => props.borderWidth ? props.borderWidth : '1px'};
        border-style: ${props => props.borderStyle ? props.borderStyle : 'solid'};
        border-color: ${props => props.borderColor ? props.borderColor : '#2f2f30'};
        text-decoration: none;
        padding: ${props => props.tabPadding ? props.tabPadding : '8px 4px 0 4px'};
        border-radius: 5px 5px 0 0;
        background-color: ${props => props.tabsBgColor ? props.tabsBgColor : '#f5f5f5'};
        font-family: inherit;
    }
    & a.active {
        border-bottom: none;
        font-weight: 450;
        background-color: ${props => props.activeTabBgColor ? props.activeTabBgColor : '#fff'};
    }
`

const EmptyTab = styled.div`
    border-bottom: 1px solid;
`

function NavigationTabs (props) {
    const links = props.children;
    return (
        <TabsContainer {...props}>
            {links}
        <EmptyTab></EmptyTab>
        </TabsContainer>
    )
}

export default NavigationTabs;